import React, { FC, Fragment, ReactNode, useEffect } from 'react';
import { CircleButton, CustomDatePicker, Input, Select } from '@ui';
import { FieldValues, useFieldArray, UseFieldArrayAppend, useFormContext } from 'react-hook-form';
import useTranslation from '@app/hooks/use-translation';

import moment from 'moment';

import { FilterOptionsListAndRules } from './types';
type NestedFieldPropsType = {
  nestIndex: number;
  appendFilter: UseFieldArrayAppend<FieldValues, string>;
  fieldsLength: number;
  fieldObject?: FilterOptionsListAndRules;
  // getConditionOptionsWhenMoreThatOneValue(): { title: string; value: string }[];
  // getConditionsSelectOptions(): { title: string; value: string }[];
  keysForFiltering: FilterOptionsListAndRules[];
  additionalObjectName?: string;
};
const AppealFilterNestedField: FC<NestedFieldPropsType> = ({
  nestIndex,
  appendFilter,
  // getConditionOptionsWhenMoreThatOneValue,
  fieldsLength,
  additionalObjectName,
  fieldObject,
  // getConditionsSelectOptions,
  // keysForFiltering,
}) => {
  const { t } = useTranslation('components.filter');
  const { control, watch, setValue } = useFormContext();
  const { fields, remove, append } = useFieldArray({
    control,
    name: `${additionalObjectName || 'filter'}[${nestIndex}].value`,
  });
  useEffect(() => {
    fields.length === 0 && append('');
  }, [append, fields, watch]);
  function onChangeValue(value: string | number, index: number) {
    if (
      !watch(`${additionalObjectName || 'filter'}[${nestIndex}].value[${index}]`) &&
      value &&
      fieldsLength === nestIndex + 1
    ) {
      appendFilter('');
    }
    setValue(`${additionalObjectName || 'filter'}[${nestIndex}].value[${index}]`, value);
  }

  function onAppendNestedField() {
    append('');
    // watch(`filter[${nestIndex}].value`).length === 2 &&
    //   setValue(
    //     `filter[${nestIndex}].condition`,
    //     getConditionOptionsWhenMoreThatOneValue()[0].value,
    //   );
  }

  function onDeleteNestedField(fieldIndex: number) {
    remove(fieldIndex);
    // watch(`filter[${nestIndex}].value`).length <= 1 &&
    //   setValue(`filter[${nestIndex}].condition`, getConditionsSelectOptions()[0].value);
  }

  const fieldByType = (
    item: Record<'id', string>,
    fieldsIndex: number,
  ): Record<Exclude<FilterOptionsListAndRules['field_type'], undefined>, ReactNode> => {
    return {
      input: (
        <Input
          defaultValue={watch(
            `${additionalObjectName || 'filter'}[${nestIndex}].value[${fieldsIndex}]`,
          )}
          onChange={(event) => {
            const value =
              fieldObject?.value_type === 'number' ? +event.target.value : event.target.value;

            if (fieldObject?.value_type === 'number' && !value) {
              return;
            }

            onChangeValue(value, fieldsIndex);
          }}
          onClick={() =>
            fieldsIndex !== fields.length - 1
              ? onDeleteNestedField(fieldsIndex)
              : onAppendNestedField()
          }
          iconColor={'primary'}
          iconDisable={fieldObject?.singleNestedField}
          {...{ icon: fieldsIndex !== fields.length - 1 ? 'MinusIcon' : 'CirclePlusIcon' }}
        />
      ),
      select: (
        <div className="relative flex items-center">
          <Select
            defaultValue={watch(
              `${additionalObjectName || 'filter'}[${nestIndex}].value[${fieldsIndex}]`,
            )}
            options={fieldObject?.select?.options || []}
            onChange={(value) => onChangeValue(value, fieldsIndex)}
          />
          {!fieldObject?.singleNestedField && (
            <div className="absolute -right-[20px]">
              <CircleButton
                icon={fieldsIndex !== fields.length - 1 ? 'MinusIcon' : 'CirclePlusIcon'}
                className="text-action"
                disable={fieldObject?.singleNestedField}
                onClick={() =>
                  fieldsIndex !== fields.length - 1
                    ? onDeleteNestedField(fieldsIndex)
                    : onAppendNestedField()
                }
              />
            </div>
          )}
        </div>
      ),
      datepicker: (
        <div className="relative flex items-center w-full grow">
          <CustomDatePicker
            selected={
              watch(`${additionalObjectName || 'filter'}[${nestIndex}].value[${fieldsIndex}]`)
                ? moment(
                    watch(
                      `${additionalObjectName || 'filter'}[${nestIndex}].value[${fieldsIndex}]`,
                    ),
                  ).toDate()
                : undefined
            }
            onChange={(value) => {
              onChangeValue(value.replace(/\./g, '-'), fieldsIndex);
            }}
            withoutDefault
            isFullCustom
            isFull
          />
          {!fieldObject?.singleNestedField && (
            <div className="absolute -right-[20px]">
              <CircleButton
                icon={fieldsIndex !== fields.length - 1 ? 'MinusIcon' : 'CirclePlusIcon'}
                className="text-action"
                disable={fieldObject?.singleNestedField}
                onClick={() =>
                  fieldsIndex !== fields.length - 1
                    ? onDeleteNestedField(fieldsIndex)
                    : onAppendNestedField()
                }
              />
            </div>
          )}
        </div>
      ),
    };
  };

  return (
    <div className={'flex flex-col items-center '}>
      {fields.map((item, fieldsIndex) => {
        return (
          <Fragment key={item.id}>
            {fieldsIndex !== 0 && (
              <div
                className={
                  'h-[17px] w-full flex items-center justify-center text-[14px] leading-[17px] font-[400] text-4color'
                }
              >
                {t('or')}
              </div>
            )}
            <div className={'w-[430px] transition-all cursor-pointer'}>
              {fieldByType(item, fieldsIndex)[fieldObject?.field_type || 'input']}
            </div>
          </Fragment>
        );
      })}
    </div>
  );
};

export default AppealFilterNestedField;
